const base = {
  namespaced: true,
  state: {
    temporarilyItemCode: localStorage.getItem("se_temporarily_item_code") || "",
    msmBalance: undefined, // 短信条数
    showPlatformParts: JSON.parse(localStorage.getItem("se_show_platform_parts") || "false"),
    showPlatformServiceItem: JSON.parse(localStorage.getItem("se-show-platform-serviceitem") || "false"),
    separator: localStorage.getItem("se_common_base_separator") || "", // 千位分隔符
    decimalPlaces: JSON.parse(localStorage.getItem("se_common_base_decimalPlaces") || '"2"'), // 小数位数
    currencyUnit: localStorage.getItem("se_common_base_currencyUnit") || "2", // 货币单位
    currencySymbol: localStorage.getItem("se_common_base_currencySymbol") || "", // 货币符号
    countryStr: localStorage.getItem("se_common_base_countryStr") || "" // 账号所属的国家信息
  },
  getters: {},
  mutations: {
    setTemporarilyItemCode(state, data) {
      state.temporarilyItemCode = data;
      localStorage.setItem("se_temporarily_item_code", data);
    },
    msmBalanceCommit(state, data) {
      state.msmBalance = data;
    },
    setShowPlatformParts(state, data) {
      state.showPlatformParts = data;
      localStorage.setItem("se_show_platform_parts", data);
    },
    setShowPlatformServiceItem(state, data) {
      state.showPlatformServiceItem = data;
      localStorage.setItem("se-show-platform-serviceitem", data);
    },
    setCurrency(state, data) {
      state.separator = data.separator;
      state.decimalPlaces = data.decimalPlaces;
      state.currencyUnit = data.currencyUnit;
      state.currencySymbol = data.currencySymbol;
      localStorage.setItem("se_common_base_separator", data.separator || "");
      localStorage.setItem("se_common_base_decimalPlaces", data.decimalPlaces || 2);
      localStorage.setItem("se_common_base_currencyUnit", data.currencyUnit || "");
      localStorage.setItem("se_common_base_currencySymbol", data.currencySymbol || "");
    },
    setCountryStr(state, data) {
      state.countryStr = data;
      localStorage.setItem("se_common_base_countryStr", data);
    }
  },
  actions: {
    async getvehicleTree({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/queryModelTree", params);
      return data;
    },
    async getAreaList({ rootState }, params = { level: 1 }) {
      const data = await rootState.http("/area/queryAreaCode", params);
      return data;
    },
    async getDictionaryList({ rootState }, dictionaryCode = "") {
      const data = await rootState.http("/basic/queryDictionaryList", {
        dataCode: dictionaryCode
      });
      if (data.data && data.data.list) {
        return data.data.list.map(item => {
          return Object.assign(item, {
            label: item.dataDesc,
            value: item.dataValue
          });
        });
      } else {
        return [];
      }
    },
    async getVehicleInfoByVin({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getVehicleListByVin", params, { errorMessage: false });
      return data;
    },
    async getSystemValue({ rootState }, name = "") {
      const data = await rootState.http("/basic/getDataValue", {
        dataCode: name
      });
      return data;
    },
    async updateSystemValue({ rootState }, params = {}) {
      const data = await rootState.http("/basic/saveDataValue", params);
      return data;
    },
    async getUploadToken({ rootState }, params = { businessType: "0" }) {
      const data = await rootState.http("/filecloud/getOssToken", params);
      return data;
    },
    async getNewOrderMessage({ rootState }, params = {}) {
      const data = await rootState.http("/external/order/message/newOrder", params);
      return data;
    },
    async createTrack({ rootState, commit, dispatch }, pageUrl) {
      const params = {
        pageUrl: pageUrl
      };
      const data = await rootState.http("/logger/trackAccess", params, { errorMessage: false });
      if (rootState.app.appVersion && rootState.app.appVersion !== data.data) {
        await dispatch("user/loginOut", {}, { root: true });
      }
      commit("app/setAppVersion", data.data, { root: true });
      return data;
    },
    async getProtocolVersion({ rootState }, params = {}) {
      const data = await rootState.http("/agreement/findLatestAgreement", params);
      return data;
    },
    async queryStoreMessageBalance({ rootState, commit }, params = {}) {
      const data = await rootState.http("/store/getMessageBalance", params);
      commit("msmBalanceCommit", data.data.smsBalance);
      return data;
    },
    async getImportResultFileAccessUrl({ rootState }, params = {}) {
      const data = await rootState.http("/filecloud/getImportResultFileAccessUrl", params);
      return data;
    },
    async queryCustomerFlagList({ rootState }, params = {}) {
      const data = await rootState.http("/customer/label/query", params);
      return data;
    },
    async saveCustomerFlag({ rootState }, params = {}) {
      const data = await rootState.http("/customer/label/save", params);
      return data;
    },
    async queryImportResult({ rootState }, params = {}) {
      const data = await rootState.http("/filecloud/queryImportResult", params);
      return data;
    },
    async queryCustomerInfoList({ rootState }, params = {}) {
      const data = await rootState.http("/customer/basic/query", params);
      return data;
    },
    async commonLabelItemSave({ rootState }, params = {}) {
      const data = await rootState.http("/common/label/save", params);
      return data;
    },
    async commonLabelItemQuery({ rootState }, params = {}) {
      const data = await rootState.http("/common/label/query", params);
      return data;
    },
    async queryImportTemplateUrl({ rootState }, params = {}) {
      const data = await rootState.http("/importTemplate/findImportTemplateUrl", params);
      return data;
    },
    async queryAreaPhonePrefix({ rootState }, params = {}) {
      const data = await rootState.http("/op/openStoreApply/queryPhonePrefix", params);
      return data;
    }
  }
};

export default base;
